import MedicalSerializer from './base';

export default class Schedule extends MedicalSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      deleted: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
